import { Box, Typography } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { isCacheEnabled, enableCache, disableCache } from '../Utils'
import ConfirmModal from '../../components/ConfirmModalV2'
import VNBlueSwitch from '../../components/VNBlueSwitch'
import { toast } from 'react-toastify'
import { bridge_getDeviceModel } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { DEVICE_MODEL } from '../../VNMode/Utils'
import { isSDKCompatible } from '../../VNAndroidSDK/Utils'
import { getAndroidSDKVersion } from '../../VNAndroidSDK/Selectors'

const SUPPORTED_DEVICES = [DEVICE_MODEL.A800]
const MIN_SUPPORTED_APK_VERSION = '3.0.0'

const CacheToggle = ({ className, styles = {} }) => {
  const [isEnabled, setIsEnabled] = useState(!!isCacheEnabled())
  const [showModal, setShowModal] = useState(false)
  const androidSDKVersion = useSelector(getAndroidSDKVersion)
  const isSupportedDevice = useCallback(() => {
    if (DEVICE_MODEL.WEB === bridge_getDeviceModel()) {
      return true
    }

    if (!isSDKCompatible(androidSDKVersion, MIN_SUPPORTED_APK_VERSION)) {
      return false
    }

    return SUPPORTED_DEVICES.includes(bridge_getDeviceModel())
  }, [androidSDKVersion])
  const { leftOption, rightOption, category } = styles

  useEffect(() => {
    if (isCacheEnabled() === isEnabled) return
    try {
      if (!isEnabled) {
        disableCache()
        return
      }
      enableCache()
    } catch (err) {
      toast.error(err)
    }
  }, [isEnabled])

  const cacheToggleHandler = (e) => {
    if (!navigator.onLine) {
      toast.error('Cannot change Application Cache while offline.')
      return
    }

    setShowModal(true)
  }

  const cancelHandler = () => {
    setShowModal(false)
  }

  const confirmHandler = () => {
    setIsEnabled(!isEnabled)
    setShowModal(false)
  }

  if (!isSupportedDevice()) {
    return null
  }

  const Modal = () => (
    <ConfirmModal
      headerText={'Application Cache'}
      subtext="You may be prompted to re-login."
      buttonOneText="CANCEL"
      onButtonOneClick={cancelHandler}
      buttonTwoText="ACCEPT"
      onButtonTwoClick={confirmHandler}
    />
  )

  return (
    <>
      {showModal && <Modal />}
      <div className={category}>Application Cache</div>
      <Box className={className}>
        <Typography className={leftOption}>Disable</Typography>
        <VNBlueSwitch checked={isEnabled} onChange={cacheToggleHandler} />
        <Typography className={rightOption}>Enable</Typography>
      </Box>
    </>
  )
}

export default CacheToggle
